import { APP_PATHS } from "../../../../../../../constants/paths";
import NavItem from "../NavItem";
import voiceOrderIcon from "../../../../../../../assets/icons/voice_order.svg";

const VoiceOrderNavItem = () => {
  return (
    <NavItem to={APP_PATHS.VOICE_ORDER.url}>
      <span>الطلب الصوتي</span>
      <img src={voiceOrderIcon} alt="voice order" />
    </NavItem>
  );
};

export default VoiceOrderNavItem;
